const initialState = {
    appliedOffer : null,
    discount:0
}

export default function billDiscountReducer (state=initialState, action){
    switch(action.type){
        case "SET_BILL_DISCOUNT":
            return {
                appliedOffer:action.payload.offer,
                discount:action.payload.discount
            }
        case "CLEAR_BILL_DISCOUNT":
            return initialState
        default:
            return state;
    }
}